;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { Logo, TeamIcon } from '@workspace/ui';
import { cn } from '@workspace/ui/lib';
import { cva } from 'class-variance-authority';
import {
  Banknote,
  Building2,
  CircleAlert,
  FileText,
  ReceiptText,
  Settings,
  ShieldCheck,
  SquareCheck,
} from 'lucide-react';
import type { NotificationType } from '@/types/notifications';

const notificationIconVariants = cva(
  'group pointer-events-none flex h-10 w-10 min-h-10 min-w-10 max-h-10 max-w-10 items-center justify-center rounded-lg bg-grey-100 p-[10px] text-secondary dark:bg-grey-100 dark:text-secondary',
  {
    variants: {
      type: {
        system: 'text-secondary',
        employees: 'text-secondary',
        payroll: 'text-secondary',
        expenses: 'text-secondary',
        invoices: 'text-secondary',
        errors: 'text-secondary',
        teams: 'text-secondary',
        team_members: 'text-secondary',
        organisation: 'text-secondary',
        settings: 'text-secondary',
        task: 'text-secondary',
        kyb: 'text-secondary',
        msa: 'text-secondary',
      },
    },
    defaultVariants: {
      type: 'system',
    },
  }
);

interface NotificationIconProps {
  type: NotificationType;
}

export default function NotificationIcon({ type }: NotificationIconProps) {
  const getIcon = () => {
    switch (type) {
      case 'system':
        return <Logo variant="symbol" color="pink" />;
      case 'employees':
        return <TeamIcon size={24} />;
      case 'teams':
      case 'team_members':
        return <TeamIcon size={24} />;
      case 'organisation':
        return <Building2 size={24} />;
      case 'settings':
        return <Settings size={24} />;
      case 'task':
        return <SquareCheck size={24} />;
      case 'kyb':
        return <ShieldCheck size={24} />;
      case 'msa':
        return <FileText size={24} />;
      case 'payroll':
        return <Banknote size={24} />;
      case 'expenses':
        return <ReceiptText size={24} />;
      case 'invoices':
        return <FileText size={24} />;
      case 'errors':
        return <CircleAlert size={24} />;
      default:
        return <CircleAlert size={24} />;
    }
  };

  return <div className={cn(notificationIconVariants({ type }))}>{getIcon()}</div>;
}
